<ng-container *ngIf="header$ | async as info">
    <div class="header-information" [class.collapse]="isHeaderEmpty(info)">
        <div class="se-left-section" [innerHtml]="info.left"></div>

        <div class="se-center-section se-center-text" [innerHtml]="info.center"></div>

        <div class="se-right-section se-right-text" [innerHtml]="info.right"></div>
    </div>
</ng-container>
